module.exports = "/images/vendor/flag-icon-css/flags/4x3/eg.svg?6b83ab95bd23daca2408f78d9381af8c";